import { create } from 'zustand'
import type { DayOfWeek } from '../lib/constants'

interface SplitUIState {
  // Modal state
  isExerciseModalOpen: boolean
  isRoutineModalOpen: boolean
  selectedDay: DayOfWeek | null
  selectedCycleDayIndex: number | null
  selectedRoutineId: string | null
  isSelectingRoutineForDay: boolean
  
  // Clipboard state for copying routines
  copiedRoutineId: string | null
  
  // Modal actions
  openExerciseModal: (day: DayOfWeek, routineId: string) => void
  closeExerciseModal: () => void
  openRoutineModal: (day: DayOfWeek) => void
  openRoutineModalForCycleDay: (dayIndex: number) => void
  closeRoutineModal: () => void
  startSelectingRoutineForDay: (day: DayOfWeek) => void
  stopSelectingRoutineForDay: () => void
  
  // Clipboard actions
  copyRoutineToClipboard: (routineId: string) => void
  clearClipboard: () => void
}

export const useSplitUIStore = create<SplitUIState>()((set) => ({
  // UI state (ephemeral - not persisted)
  isExerciseModalOpen: false,
  isRoutineModalOpen: false,
  selectedDay: null,
  selectedCycleDayIndex: null,
  selectedRoutineId: null,
  isSelectingRoutineForDay: false,
  copiedRoutineId: null,
  
  // Modal actions
  openExerciseModal: (day, routineId) => {
    set({ 
      isExerciseModalOpen: true, 
      selectedDay: day,
      selectedRoutineId: routineId 
    })
  },
  
  closeExerciseModal: () => {
    set({ 
      isExerciseModalOpen: false, 
      selectedDay: null,
      selectedRoutineId: null 
    })
  },
  
  openRoutineModal: (day) => {
    set({ 
      isRoutineModalOpen: true, 
      selectedDay: day,
      selectedCycleDayIndex: null
    })
  },
  
  openRoutineModalForCycleDay: (dayIndex) => {
    set({ 
      isRoutineModalOpen: true, 
      selectedDay: null,
      selectedCycleDayIndex: dayIndex
    })
  },
  
  closeRoutineModal: () => {
    set({ 
      isRoutineModalOpen: false, 
      selectedDay: null,
      selectedCycleDayIndex: null
    })
  },
  
  startSelectingRoutineForDay: (day) => {
    set({ 
      isSelectingRoutineForDay: true,
      selectedDay: day 
    })
  },
  
  stopSelectingRoutineForDay: () => {
    set({ 
      isSelectingRoutineForDay: false,
      selectedDay: null 
    })
  },
  
  // Clipboard actions
  copyRoutineToClipboard: (routineId) => {
    set({ copiedRoutineId: routineId })
  },
  
  clearClipboard: () => {
    set({ copiedRoutineId: null })
  }
}))